var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-task-register-contents"},[_c('Breadcrumb',{attrs:{"links":_vm.links,"data":{name: 'Tarefa', id: _vm.currentTask.id}}}),_c('form',{staticClass:"content-task-register-contents-form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('CardContentsTask')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }